import React from "react";
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import { FormikValues, useFormik } from "formik";
import { CreateUserSchema } from "./../validations/Schema";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import { MuiDropDown } from "./../components/basicComponent/MuiDropDown";
import EditIcon from '@mui/icons-material/Edit';
import MuiButton from "./../components/basicComponent/MuiButton";
import DeleteIcon from '@mui/icons-material/Delete';

const IPConfiguration = () => {
  const agentData = [
    {
      module: "B2B",
      agentName: "Demo",
      agentId: "EEAUH0000101",
      userName: "",
      ipAddress: "",
      otpRequired: "Yes",
      mailOtp: "Yes",
      smsOtp: "Yes",
      status: "Active",
    },
    {
      module: "BOA",
      agentName: "",
      agentId: "",
      userName: "Tesepr",
      ipAddress: "",
      otpRequired: "No",
      mailOtp: "No",
      smsOtp: "No",
      status: "Active",
    },
  ];

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">IP-Configuration</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiInput
                          label="Business Unit"
                          placeholder="Business Unit"
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiInput
                          label="Customer"
                          placeholder="Enter Customer"
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiInput
                          label="IP - Address"
                          placeholder="IP - Address"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label="OTP Required"
                          placeholder="Enter OTP Required"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDropDown
                          label="OTP Type"
                          placeholder="OTP Type"
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton
                            className="clear-btn "
                            label="Clear"
                            type="submit"
                          />
                          <MuiButton
                            label="Update"
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                          />
                           <MuiButton
                            label="View"
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="table-responsive">
                        <table className="table table-bordered table-hover text-nowrap mb-0">
                          <thead className="table-dark">
                            <tr>
                              <th>Module</th>
                              <th>Agent Name</th>
                              <th>Agent ID</th>
                              <th>User Name</th>
                              <th>IP Address</th>
                              <th>OTP Required</th>
                              <th>Mail OTP</th>
                              <th>SMS OTP</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {agentData.map((agent, index) => (
                              <tr key={index}>
                                <td>{agent.module}</td>
                                <td>{agent.agentName}</td>
                                <td>{agent.agentId}</td>
                                <td>{agent.userName}</td>
                                <td>{agent.ipAddress}</td>
                                <td>{agent.otpRequired}</td>
                                <td>{agent.mailOtp}</td>
                                <td>{agent.smsOtp}</td>
                                <td>
                                  <a
                                    href="#"
                                    className="text-decoration-underline text-dark"
                                  >
                                    {agent.status}
                                  </a>
                                </td>
                                <td>
                                  <button className="btn btn-sm btn-outline-primary me-2">
                                    <EditIcon />
                                  </button>
                                  <button className="btn btn-sm btn-outline-danger">
                                    <DeleteIcon />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="text-end p-2">
                        <small>{`1 - ${agentData.length} of ${agentData.length}`}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default IPConfiguration;
